import React from "react";
import MetaTags from "react-meta-tags";
import {
  HiOutlineAcademicCap,
  HiOutlineArrowLeft,
  HiOutlineBookOpen,
  HiOutlineBriefcase,
  HiOutlineCamera,
  HiOutlineCheckCircle,
  HiOutlineClipboardDocumentCheck,
  HiOutlineDocumentText,
  HiOutlineHome,
  HiOutlineIdentification,
  HiOutlineMapPin,
  HiOutlineMegaphone,
  HiOutlinePencilSquare,
  HiOutlineSparkles,
  HiOutlineUserGroup,
} from "react-icons/hi2";
import "./Present.css";

const base = process.env.REACT_APP_BASENAME || "";

export const PRESENT_STEPS = [
  {
    step: 1,
    path: "/Insertpresent1",
    label: "ประวัติส่วนตัว",
    short: "ส่วนตัว",
    Icon: HiOutlineIdentification,
  },
  {
    step: 2,
    path: "/Insertpresent2",
    label: "ประวัติการศึกษา",
    short: "การศึกษา",
    Icon: HiOutlineBookOpen,
  },
  {
    step: 3,
    path: "/Insertpresent3",
    label: "ที่อยู่",
    short: "ที่อยู่",
    Icon: HiOutlineMapPin,
  },
  {
    step: 4,
    path: "/Insertpresent4",
    label: "ผู้ปกครอง",
    short: "ผู้ปกครอง",
    Icon: HiOutlineUserGroup,
  },
  {
    step: 5,
    path: "/Insertpresent5",
    label: "การมีงานทำ",
    short: "งานทำ",
    Icon: HiOutlineBriefcase,
  },
  {
    step: 6,
    path: "/Insertpresent6",
    label: "ความสามารถพิเศษ",
    short: "พิเศษ",
    Icon: HiOutlineSparkles,
  },
  {
    step: 7,
    path: "/Insertpresent7",
    label: "ช่องทางข่าวสาร",
    short: "ข่าวสาร",
    Icon: HiOutlineMegaphone,
  },
  {
    step: 8,
    path: "/Insertpresent8",
    label: "รูปประจำตัว",
    short: "รูป",
    Icon: HiOutlineCamera,
  },
  {
    step: 9,
    path: "/Insertpresent9",
    label: "เอกสารประกอบ",
    short: "เอกสาร",
    Icon: HiOutlineDocumentText,
  },
  {
    step: 10,
    path: "/Insertpresent10",
    label: "ผลคะแนน TPAT 5",
    short: "TPAT5",
    Icon: HiOutlineAcademicCap,
  },
];

export function getPresentSteps(includeTpat = false) {
  return includeTpat ? PRESENT_STEPS : PRESENT_STEPS.filter((s) => s.step !== 10);
}

/**
 * Shared shell for present registration steps.
 */
export default function PresentLayout({
  step = null,
  title,
  metaTitle,
  metaDescription,
  includeTpat = false,
  showRequiredHint = true,
  children,
  actions = null,
}) {
  const steps = getPresentSteps(includeTpat);
  const pageTitle = metaTitle || `${title} | รายงานตัว มหาวิทยาลัยราชภัฏกำแพงเพชร`;

  return (
    <>
      <MetaTags>
        <title>{pageTitle}</title>
        <meta
          name="description"
          content={
            metaDescription ||
            `${title} ระบบรายงานตัว มหาวิทยาลัยราชภัฏกำแพงเพชร`
          }
        />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:image" content="../../public/favicon.ico" />
      </MetaTags>

      <div className="present-flow">
        <div className="present-flow__hero">
          <p className="present-flow__eyebrow">มหาวิทยาลัยราชภัฏกำแพงเพชร</p>
          <h1 className="present-flow__title">
            <HiOutlineClipboardDocumentCheck size={26} aria-hidden />
            {title}
          </h1>
          <p className="present-flow__desc">กรอกข้อมูลรายงานตัวทีละขั้นตอนให้ครบถ้วน</p>
        </div>

        <nav className="present-flow__steps" aria-label="ขั้นตอนรายงานตัว">
          <a
            className={`present-flow__step${step == null ? " is-active" : ""}`}
            href={`${base}/Present`}
          >
            <span className="present-flow__step-num" aria-hidden="true">
              <HiOutlineHome size={14} />
            </span>
            ภาพรวม
          </a>
          {steps.map((item) => {
            const active = Number(step) === item.step;
            const done = step != null && Number(step) > item.step;
            const StepIcon = item.Icon;
            return (
              <a
                key={item.step}
                className={`present-flow__step${active ? " is-active" : ""}${
                  done ? " is-done" : ""
                }`}
                href={`${base}${item.path}`}
              >
                <span className="present-flow__step-num" aria-hidden="true">
                  {done ? <HiOutlineCheckCircle size={14} /> : <StepIcon size={14} />}
                </span>
                {item.short}
              </a>
            );
          })}
        </nav>

        <div className="present-flow__panel">
          {step != null && title ? (
            <h2 className="present-flow__panel-title">{title}</h2>
          ) : null}
          {step != null && showRequiredHint ? (
            <span className="present-flow__required">* จำเป็นต้องกรอกข้อมูล</span>
          ) : null}
          {children}
          {actions ? <div className="present-flow__actions">{actions}</div> : null}
          {step != null ? (
            <div className="present-flow__actions">
              <a className="present-flow__back" href={`${base}/Present`}>
                <HiOutlineArrowLeft size={16} aria-hidden />
                กลับหน้าภาพรวมรายงานตัว
              </a>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
}

export function PresentHubCards({ stepsStatus, includeTpat = false }) {
  const steps = getPresentSteps(includeTpat);
  const doneCount = steps.filter((item) => !stepsStatus[item.step]).length;

  return (
    <div className="present-hub__list-wrap">
      <div className="present-hub__list-head">
        <span>รายการขั้นตอนที่ต้องกรอก</span>
        <span className="present-hub__list-count">
          ครบแล้ว {doneCount}/{steps.length} รายการ
        </span>
      </div>
      <ol className="present-hub__list">
        {steps.map((item) => {
          const pending = Boolean(stepsStatus[item.step]);
          const StepIcon = item.Icon;
          return (
            <li
              key={item.step}
              className={`present-hub__row${pending ? " is-todo" : " is-done"}`}
            >
              <div className="present-hub__row-main">
                <span className="present-hub__row-num" aria-hidden="true">
                  <StepIcon size={18} />
                </span>
                <div className="present-hub__row-text">
                  <h3 className="present-hub__row-title">{item.label}</h3>
                  <p className="present-hub__row-status">
                    {pending ? "ยังไม่ได้กรอกหรือยังไม่ครบ" : "กรอกข้อมูลเรียบร้อยแล้ว"}
                  </p>
                </div>
              </div>
              <div className="present-hub__row-side">
                <span className={`present-hub__badge${pending ? " is-todo" : " is-done"}`}>
                  {pending ? "ยังไม่ครบ" : "ครบแล้ว"}
                </span>
                <a
                  className={`present-hub__row-action${pending ? " is-todo" : " is-done"}`}
                  href={`${base}${item.path}`}
                >
                  {pending ? (
                    <>
                      <HiOutlinePencilSquare size={15} aria-hidden />
                      กรอกข้อมูล
                    </>
                  ) : (
                    <>
                      <HiOutlinePencilSquare size={15} aria-hidden />
                      แก้ไข
                    </>
                  )}
                </a>
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
